import styled from 'styled-components'

export const Outer = styled.section`
  background-image: linear-gradient(56deg, #505aff 0%, #7175bd 100%);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 4rem 2rem;
  position: relative;
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 850px) {
    display: none;
  }
  max-width: 1243px;
  width: 100%;
  .active {
    .upper {
      opacity: 1;
    }
    .lower {
      color: white;
      font-size: 50px;
      margin-right: 20px;
      &:after {
        opacity: 1;
      }
      @media only screen and (max-width: 1084px) {
        font-size: 35px;
      }
    }
  }
  > div {
    cursor: pointer;
    flex: 1;
    position: relative;
    &:focus {
      outline: 0;
    }
    &:not(:first-child) {
      &:before {
        content: '';
        position: absolute;
        transform: translate(-34px, 44px);
        display: block;
        width: 6px;
        height: 66px;
        background-color: #c1b7fe;
      }
    }
    .upper {
      opacity: 0;
      color: #00d7d7;
      font-size: 21px;
      @media only screen and (max-width: 1084px) {
        font-size: 16px;
      }
      margin-bottom: 12px;
      transition: ease-in opacity 0.4s 0.2s;
      font-weight: 500;
    }
    .lower {
      font-size: 40px;
      color: #c1b7fe;
      font-weight: 700;
      line-height: 64px;
      margin-bottom: 12px;
      @media only screen and (max-width: 1084px) {
        font-size: 22px;
      }
      transition: ease-in color 0.4s, ease-in font-size 0.3s;
      &:after {
        content: '';
        display: block;
        width: 109px;
        height: 6px;
        margin-top: 12px;
        background-color: #00d7d7;
        transition: ease-in opacity 0.4s;
        opacity: 0;
      }
    }
  }
`

export const SlideDisplay = styled.div`
  display: flex;
  max-width: 1243px;
  width: 100%;
  @media only screen and (max-width: 850px) {
    padding-top: 2rem;
    flex-direction: column;
  }
  jusitfy-content: center;
  align-items: center;
  padding-top: 4rem;
  > p {
    max-width: 300px;
    @media only screen and (max-width: 850px) {
      max-width: 100%;
      margin: 0;
      font-size: 18px;
      padding: 2rem 0 0;
    }
    line-height: 1.28;
    font-size: 20.5px;
    color: white;
    height: auto;
  }
`

export const MobileHeads = styled.div`
  width: 100%;
  margin-bottom: 30px;
  display: none;
  @media only screen and (max-width: 850px) {
    display: block;
  }
  .active {
    .upper {
      opacity: 1;
    }
    .lower {
      color: white;
      font-size: 50px;
      margin-right: 20px;
      &:after {
        opacity: 1;
      }
    }
  }

  .upper {
    opacity: 0;
    color: #00d7d7;
    font-size: 21px;

    margin-bottom: 12px;
    transition: ease-in opacity 0.4s 0.2s;
    font-weight: 500;
  }
`

export const GraphicWrapper = styled.div`
  max-width: 827px;
  width: 100%;
  flex: 5;
`

export const MobileDots = styled.div`
  display: none;
  @media only screen and (max-width: 850px) {
    display: flex;
  }
  font-family: Arial;
  font-size: 28px;
  padding: 2rem 1rem 0;
  > div {
    padding: 0.2rem;
    transition: all 0.3s ease-in;
  }

  opacity: 0.7;
  .active {
    color: #00d7d7;
    opacity: 1;
  }
  color: white;
`
